module.exports = __webpack_public_path__ + "img/IEC13806.42322151.png";